// Notifications plugin. Used on Notifications page
import Notifications from '@/components/NotificationPlugin'
// Validation plugin used to validate forms
import VeeValidate from 'vee-validate'
// A plugin file where you could register global mixins used across the app
import GlobalMixins from './globalMixins'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'

// library auto imports
import 'es6-promise/auto'

export default {
  install(Vue) {
    Vue.use(GlobalComponents)
    Vue.use(GlobalMixins)
    Vue.use(GlobalDirectives)
    Vue.use(Notifications)
    Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
  },
}


// WEBPACK FOOTER //
// ./src/material-dashboard.js